import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		label: {
			fontWeight: "bold"
		},
		sectionHeader: {
			fontWeight: 'bold',
			fontSize: 18,
		},
		fieldLabel: {
			color: theme.palette.text.secondary,
			fontSize: 16,
			marginBottom: 16,
			display: 'flex',
			alignItems: 'center',
			gap: 8,
		},
		toggleContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: 16,
			alignItems: 'flex-start',
		},
		toggleLabel: {
			fontSize: 16,
			fontWeight: "bold",
			color: theme.palette.text.primary,
		},
		toggleLabelContent: {
			marginLeft: 4,
			marginTop: 8,
		},
		divider: {
			marginTop: 24,
			marginBottom: 24,
		},
		saveButton: {
			marginRight: 8,
		},
		infoIcon: {
			padding: 0,
			width: 20,
			height: 20,
			marginLeft: 8,
		},
		dropdownContainer: {
			maxWidth: 576,
		},
		radioGroupStacked: {
			marginTop: 4,
			alignItems: "flex-start",
			"& .MuiFormControlLabel-root": {
				marginLeft: -9,
			},
		},
		marketLink: {
			color: theme.palette.primary.main,
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline",
			},
		},
		introText: {
			color: theme.palette.text.secondary,
			marginBottom: 8,
		},
		sectionDescription: {
			color: theme.palette.custom.textPrimary,
			marginTop: 4,
		},

	} satisfies Record<string, CSSObject>);
};
